import React, { useState, useEffect } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { Helmet } from 'react-helmet-async';
import Modal from 'react-bootstrap/Modal';
import './css/gererRestaurant.css';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { AjouteRestaurants, AfficheRestaurant, SuprimerRestaurant, ModifierRestaurant, EnvoyeEmail, AuthRestaurantRequest } from '../../Api/SocieteApi/RestaurantApi';
import { useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { useDispatch } from 'react-redux';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { AjouteRestaurant } from '../../Redux/actions/actionRestaurant';
import { AjouteUrlSociete } from '../../Redux/actions/actionUrlSociete';

const GererRestaurant = () => {
  const [showAjoute, setShowAjoute] = useState(false);
  const [showModifier, setShowModifier] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [loadRestaurant, setLoadRestaurant] = useState(false);
  const [dataRestaurant, setDataRestaurant] = useState([]);
  const [restaurantPaginate, setRestaurantPaginate] = useState([]);
  const [showPaginate, setShowPaginate] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [page, setPage] = useState(1);


  const [nomRestaurant, setNomRestaurant] = useState('');
  const [ville, setVille] = useState('');
  const [adresse, setAdresse] = useState('');
  const [codePostal, setCodePostal] = useState('');
  const [email, setEmail] = useState('');
  const [nombrePersonne, setNombrePersonne] = useState('');
  const [telephone, setTelephone] = useState('');
  const [nomGerant, setNomGerant] = useState('');
  const [prenomGerant, setPrenomGerant] = useState('');
  const [emailGerant, setEmailGerant] = useState('');
  const [telephoneFix, setTelephoneFix] = useState('');
  const [telephonePortable, setTelephonePortable] = useState('');
  const [autreTelephone, setAutreTelephone] = useState('');
  const [nombreSalarier, setNombreSalarier] = useState('');
  const [commentaire, setCommentaire] = useState('');
  const [equipementWifi, setEquipementWifi] = useState('');
  const [equipementAdditionnelle, setEquiopempentAdditionnelle] = useState('');
  const [remarque, setRemarque] = useState('');
  const [abonnement, setAbonnement] = useState('');

  const [errorField, setErrorField] = useState({
    nomRestaurant: '',
    ville: '',
    adresse: '',
    codePostal: '',
    email: '',
    nombrePersonne: '',
    telephone: '',
    nomGerant: '',
    prenomGerant: '',
    emailGerant: '',
    telephoneFix: '',
    telephonePortable: '',
    autreTelephone: '',
    nombreSalarier: '',
    commentaire: '',
    equipementWifi: '',
    equipementAdditionnelle: '',
    remarque: '',
    abonnement: ''
  });



  const [updateId, setUpdateId] = useState('');
  const [loadUpdate, setLoadUpdate] = useState(false);
  const [nomRestaurantUpdate, setNomRestaurantUpdate] = useState('');
  const [villeUpdate, setVilleUpdate] = useState('');
  const [adresseUpdate, setAdresseUpdate] = useState('');
  const [codePostalUpdate, setCodePostaUpdate] = useState('');
  const [emailUpdate, setEmailUpdate] = useState('');
  const [nombrePersonneUpdate, setNombrePersonneUpdate] = useState('');
  const [telephoneUpdate, setTelephoneUpdate] = useState('');
  const [nomGerantUpdate, setNomGerantUpdate] = useState('');
  const [prenomGerantUpdate, setPrenomGerantUpdate] = useState('');
  const [emailGerantUpdate, setEmailGerantUpdate] = useState('');
  const [telephoneFixUpdate, setTelephoneFixUpdate] = useState('');
  const [telephonePortableUpdate, setTelephonePortableUpdate] = useState('');
  const [autreTelephoneUpdate, setAutreTelephoneUpdate] = useState('');
  const [nombreSalarierUpdate, setNombreSalarierUpdate] = useState('');
  const [commentaireUpdate, setCommentaireUpdate] = useState('');
  const [equipementWifiUpdate, setEquipementWifiUpdate] = useState('');
  const [equipementAdditionnelleUpdate, setEquipementAdditionnelleUpdate] = useState('');
  const [remarqueUpdate, setRemarqueUpdate] = useState('');
  const [abonnementUpdate, setAbonnementUpdate] = useState('');


  const [errorFieldUpdate, setErrorFieldUpdate] = useState({
    nomRestaurantUpdate: '',
    villeUpdate: '',
    adresseUpdate: '',
    codePostalUpdate: '',
    emailUpdate: '',
    nombrePersonneUpdate: '',
    telephoneUpdate: '',
    nomGerantUpdate: '',
    prenomGerantUpdate: '',
    emailGerantUpdate: '',
    telephoneFixUpdate: '',
    telephonePortableUpdate: '',
    autreTelephoneUpdate: '',
    nombreSalarierUpdate: '',
    commentaireUpdate: '',
    equipementWifiUpdate: '',
    equipementAdditionnelleUpdate: '',
    remarqueUpdate: '',
    abonnementUpdate: ''
  });


  const [loadEmail, setLoadEmail] = useState(false);
  const [sujet, setSujet] = useState('');
  const [contenu, setContenu] = useState('');

  const [dataResto, setDataResto] = useState([]);
  const [loadValue, setLoadValue] = useState(false);
  const [dataFilter, setDatafilter] = useState([]);

  const [loading, setLoading] = useState(false);

  let location = useLocation();
  let dispatch = useDispatch();
  let navigate = useNavigate();


  const [dataAbonnement, setDataAbonnement] = useState([
    {
      id: 0,
      libelle: "Selectionner un Abonnement",
      value: ""
    },
    {
      id: 1,
      libelle: "Formule A",
      value: "Formule A"
    },
    {
      id: 2,
      libelle: "Formule B",
      value: "Formule B"
    },
    {
      id: 3,
      libelle: "Formule C",
      value: "Formule C"
    }
  ]);

  const villeListe = [
    { "id": 0, "label": "Selectionner un ville", "value": "" },
    { "id": 1, "label": "Antananarivo ", "value": "Antananarivo" },
    { "id": 2, "label": "Toamasina ", "value": "Toamasina" },
    { "id": 3, "label": "Antsirabe", "value": "Antsirabe" },
    { "id": 4, "label": "Mahajanga ", "value": "Mahajanga" },
    { "id": 5, "label": "Fianarantsoa", "value": "Fianarantsoa" },
    { "id": 6, "label": "Toliara ", "value": "Toliara" },
    { "id": 7, "label": "Antsiranana ", "value": "Antsiranana" },
    { "id": 8, "label": "Morondava", "value": "Morondava" },
    { "id": 9, "label": "Ambanja", "value": "Ambanja" },
    { "id": 10, "label": "Nosy Be ", "value": "Nosy Be" },
    { "id": 11, "label": "Ambatondrazaka", "value": "Ambatondrazaka" },
    { "id": 12, "label": "Ambositra", "value": "Ambositra" },
    { "id": 13, "label": "Ambovombe", "value": "Ambovombe" },
    { "id": 14, "label": "Ampanihy", "value": "Ampanihy" },
    { "id": 15, "label": "Ambilobe", "value": "Ambilobe" },
    { "id": 16, "label": "Andoany", "value": "Andoany" },
    { "id": 17, "label": "Anjozorobe", "value": "Anjozorobe" },
    { "id": 18, "label": "Ankazobe", "value": "Ankazobe" },
    { "id": 19, "label": "Antalaha", "value": "Antalaha" },
    { "id": 20, "label": "Antsohihy", "value": "Antsohihy" },
    { "id": 21, "label": "Arivonimamo", "value": "Arivonimamo" },
    { "id": 22, "label": "Bealanana", "value": "Bealanana" },
    { "id": 23, "label": "Belo-sur-Tsiribihina", "value": "Belo-sur-Tsiribihina" },
    { "id": 24, "label": "Betafo", "value": "Betafo" },
    { "id": 25, "label": "Brickaville", "value": "Brickaville" },
    { "id": 26, "label": "Farafangana", "value": "Farafangana" },
    { "id": 27, "label": "Ihosy", "value": "Ihosy" },
    { "id": 28, "label": "Ikalamavony", "value": "Ikalamavony" },
    { "id": 29, "label": "Manakara", "value": "Manakara" },
    { "id": 30, "label": "Mananjary", "value": "Mananjary" },
    { "id": 31, "label": "Maroantsetra", "value": "Maroantsetra" },
    { "id": 32, "label": "Miandrivazo", "value": "Miandrivazo" },
    { "id": 33, "label": "Moramanga", "value": "Moramanga" },
    { "id": 34, "label": "Sambava", "value": "Sambava" },
    { "id": 35, "label": "Tsiroanomandidy", "value": "Tsiroanomandidy" },
    { "id": 36, "label": "Vangaindrano", "value": "Vangaindrano" },
    { "id": 37, "label": "Vatomandry", "value": "Vatomandry" },
    { "id": 38, "label": "Vohipeno", "value": "Vohipeno" }
  ]




  useEffect(() => {
    AfficheRestaurantData();
  }, []);

  useEffect(() => {
    if (dataRestaurant.length <= 10) {
      setShowPaginate(false);
    } else {
      setShowPaginate(true);
    }
  }, [dataRestaurant.length]);


  const AfficheRestaurantData = (value = null) => {
    let dataPage = value === null ? page : value;
    setLoadRestaurant(true);
    AfficheRestaurant(dataPage).then(function (response) {
      console.log('Liste Restaurant =>', response.data.donner);
      setDataResto(response.data.dataResto);
      setDataRestaurant(response.data.restaurants);
      setRestaurantPaginate(response.data.donner);
      setTotalPage(response.data.totalPage)
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadRestaurant(false);
    });
  }


  const handleAbonnement = (e) => {
    setAbonnement(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      abonnement: "",
    }));
  }

  const handleNomRestaurant = (e) => {
    setNomRestaurant(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      nomRestaurant: "",
    }));

  }

  const handleVille = (e) => {
    setVille(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      ville: "",
    }));
  }

  const handleAdresse = (e) => {
    setAdresse(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      adresse: "",
    }));
  }

  const handleEmail = (e) => {
    const isValid = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
    if (!isValid && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        email: "La structure de votre courriel n'est pas correcte.",
      }));
      setEmail(e.target.value);
    } else {
      setEmail(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }
  }

  const handleCodePostal = (e) => {
    setCodePostal(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      codePostal: "",
    }));
  }

  const handleNombrePersonne = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombrePersonne: "Numérique uniquement",
      }));

    } else {
      setNombrePersonne(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombrePersonne: "",
      }));
    }
  }

  const handleNomGerant = (e) => {
    setNomGerant(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      nomGerant: "",
    }));
  }

  const handlePrenomGerant = (e) => {
    setPrenomGerant(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      prenomGerant: "",
    }));
  }


  const handleEmailGerant = (e) => {
    const isValid = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
    if (!isValid && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        emailGerant: "La structure de votre courriel n'est pas correcte.",
      }));
      setEmailGerant(e.target.value);
    } else {
      setEmailGerant(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        emailGerant: "",
      }));
    }
  }

  const handleTelephoneFix = (e) => {

    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephoneFix: "Numérique uniquement",
      }));

    } else {
      setTelephoneFix(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephoneFix: "",
      }));
    }
  }


  const handleTelephonePortable = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephonePortable: "Numérique uniquement",
      }));

    } else {
      setTelephonePortable(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephonePortable: "",
      }));
    }
  }


  const handleAutreTelephone = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        autreTelephone: "Numérique uniquement",
      }));

    } else {
      setAutreTelephone(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        autreTelephone: "",
      }));
    }
  }

  const handleNombreSalarier = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombreSalarier: "Numérique uniquement",
      }));

    } else {
      setNombreSalarier(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombreSalarier: "",
      }));
    }
  }

  const handleCommentaire = (e) => {
    setCommentaire(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      commentaire: "",
    }));
  }


  const handleEquipementAdditionelle = (e) => {
    setEquiopempentAdditionnelle(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      equipementAdditionnelle: "",
    }));
  }



  const handleEquipementWifi = (e) => {
    setEquipementWifi(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      equipementWifi: "",
    }));
  }

  const handleRemarque = (e) => {
    setRemarque(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      remarque: "",
    }));
  }

  const handleTelephone = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephone: "Numérique uniquement",
      }));

    } else {
      setTelephone(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephone: "",
      }));
    }
  }


  const handleAddRestaurant = (e) => {
    e.preventDefault();
    if (nomRestaurant === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nomRestaurant: "Nom du restaurant obligatoire",
      }));
    } else if (nomRestaurant.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nomRestaurant: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nomRestaurant: "",
      }));
    }

    if (ville === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        ville: "Ville obligatoire",
      }));
    } else if (ville.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        ville: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        ville: "",
      }));
    }

    if (adresse === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        adresse: "Adresse obligatoire",
      }));
    } else if (adresse.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        adresse: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        adresse: "",
      }));
    }

    if (codePostal === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        codePostal: "Code postal obligatoire",
      }));
    } else if (codePostal.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        codePostal: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        codePostal: "",
      }));
    }

    if (email === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        email: "Adresse email obligatoire",
      }));
    } else if (email.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        email: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
    }

    if (nombrePersonne === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombrePersonne: "Nombre personne obligatoire",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombrePersonne: "",
      }));
    }

    if (telephone === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephone: "Téléphone obligatoire",
      }));
    } else if (telephone?.length < 3) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephone: "Minimum 3 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephone: "",
      }));
    }

    if (nomGerant === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nomGerant: "Nom du gérant obligatoire",
      }));
    } else if (nomGerant.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nomGerant: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nomGerant: "",
      }));
    }

    if (prenomGerant === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        prenomGerant: "Prénom du gérant obligatoire",
      }));
    } else if (prenomGerant.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        prenomGerant: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        prenomGerant: "",
      }));
    }


    if (emailGerant === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        emailGerant: "Adresse email du gérant obligatoire",
      }));
    } else if (emailGerant.length < 2) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        emailGerant: "Minimum 2 caractère",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        emailGerant: "",
      }));
    }


    if (abonnement === "") {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        abonnement: "Abonnement obligatoire",
      }));
    } else {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        abonnement: "",
      }));
    }



    const isValidEmail = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(email);
    const isValidEmailGerant = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(emailGerant);
    if (isValidEmail && isValidEmailGerant && nomRestaurant !== "" && adresse !== "" && telephone !== "" && email !== "" && codePostal !== "" && nomGerant !== "" && prenomGerant !== "" && emailGerant !== "" && ville !== "" && abonnement !== "" && nombrePersonne !== "") {
      setLoadRestaurant(true);

      const data = {
        nomRestaurant: nomRestaurant, adresse: adresse, telephone: telephone,
        codePostal: codePostal, email: email, nomGerant: nomGerant, prenomGerant: prenomGerant,
        emailGerant: emailGerant, telephoneFix: telephoneFix, telephonePortable: telephonePortable,
        autreTelephone: autreTelephone, nombreSalarier: nombreSalarier, commentaire: commentaire,
        equipementAdditionnelle: equipementAdditionnelle, equipementWifi: equipementWifi, remarque: remarque,
        ville: ville, nombrePersonne: nombrePersonne, abonnement: abonnement
      };

      AjouteRestaurants(data).then(function (response) {
        if (response.data.title === "success") {
          AfficheRestaurantData();
          toast.success(response.data?.message);
        }
      }).catch(function (error) {
        console.log(error.response);
        toast.warning(error.response.data?.message);
      }).finally(function () {
        setShowAjoute(false);
        setLoadRestaurant(false);
        setNomRestaurant('');
        setVille('');
        setAdresse('');
        setCodePostal('');
        setEmail('');
        setNombrePersonne('');
        setTelephone('');
        setNomGerant('');
        setPrenomGerant('');
        setEmailGerant('');
        setTelephoneFix('');
        setTelephonePortable('');
        setAutreTelephone('');
        setNombreSalarier('');
        setCommentaire('');
        setEquiopempentAdditionnelle('')
        setEquipementWifi('');
        setRemarque('');
        setAbonnement('');


      });
    }


  }

  console.log(errorField);

  const handlePage = (event, value) => {
    setPage(value);
    AfficheRestaurantData(value);
  }

  function formatDate(value) {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }


  const handleExportExel = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dataRestaurant);
    XLSX.utils.book_append_sheet(wb, ws, "Lites Restaurants");
    XLSX.writeFile(wb, "Restaurants.xlsx");
  }



  const handleEnvoyeEmail = (e) => {
    e.preventDefault();
    setLoadEmail(true);
    const data = { sujet: sujet, contenu: contenu };
    EnvoyeEmail(data).then(function (response) {
      if (response.data.title === "success") {
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadEmail(false);
      setShowEmail(false);
      setSujet('');
      setContenu('');

    });
  }


  const hendleDeleteRestaurant = (idRestaurant) => {
    setLoadRestaurant(true);

    SuprimerRestaurant(idRestaurant).then(function (response) {
      if (response.data.title === "success") {
        AfficheRestaurantData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadRestaurant(false);
    });

  }

  const handleShowModifier = (item) => {
    setShowModifier(true);
    setUpdateId(item.id);
    setNomRestaurantUpdate(item.nomRestaurant);
    setVilleUpdate(item.ville);
    setAdresseUpdate(item.adresse);
    setCodePostaUpdate(item.codePostal);
    setEmailUpdate(item.email);
    setNombrePersonneUpdate(item.nombrePersonne);
    setTelephoneUpdate(item.telephone);
    setNomGerantUpdate(item.nomGerant);
    setPrenomGerantUpdate(item.prenomGerant);
    setEmailGerantUpdate(item.emailGerant);
    setTelephoneFixUpdate(item.telephoneFix);
    setTelephonePortableUpdate(item.telephonePortable);
    setAutreTelephoneUpdate(item.autreTelephone);
    setNombreSalarierUpdate(item.nombreSalarier);
    setCommentaireUpdate(item.commentaire);
    setEquipementAdditionnelleUpdate(item.equipementAditionnelle);
    setEquipementWifiUpdate(item.equipementWifi);
    setRemarqueUpdate(item.remarque);
    setAbonnementUpdate(item.abonnement);
  }





  const handleUpdateAbonnement = (e) => {
    setAbonnementUpdate(e.target.value);
    setErrorFieldUpdate((prevErrors) => ({
      ...prevErrors,
      abonnementUpdate: "",
    }));
  }


  const handleNomRestaurantUpdate = (e) => {
    setNomRestaurantUpdate(e.target.value);
    setErrorFieldUpdate((prevErrors) => ({
      ...prevErrors,
      nomRestaurantUpdate: "",
    }));
  }


  const handleVilleUpdate = (e) => {
    setVilleUpdate(e.target.value);
    setErrorFieldUpdate((prevErrors) => ({
      ...prevErrors,
      villeUpdate: "",
    }));
  }

  const handleAdresseUpdate = (e) => {
    setAdresseUpdate(e.target.value);
    setErrorFieldUpdate((prevErrors) => ({
      ...prevErrors,
      adresseUpdate: "",
    }));
  }

  const handleCodePostalUpdate = (e) => {
    setCodePostaUpdate(e.target.value);
    setErrorFieldUpdate((prevErrors) => ({
      ...prevErrors,
      codePostalUpdate: "",
    }));
  }

  const handleEmailUpdate = (e) => {
    const isValid = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
    if (!isValid && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        emailUpdate: "La structure de votre courriel n'est pas correcte.",
      }));
      setEmailUpdate(e.target.value);
    } else {
      setEmailUpdate(e.target.value);
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailUpdate: "",
      }));
    }
  }

  const handleNombrePersonneUpdate = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombrePersonneUpdate: "Numérique uniquement",
      }));

    } else {
      setNombrePersonneUpdate(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        nombrePersonneUpdate: "",
      }));
    }
  }

  const handleTelephoneUpdate = (e) => {
    const isValidNumeric = /^[0-9+]+$/.test(e.target.value);
    if (!isValidNumeric && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephoneUpdate: "Numérique uniquement",
      }));

    } else {
      setTelephoneUpdate(e.target.value);
      setErrorField((prevErrors) => ({
        ...prevErrors,
        telephoneUpdate: "",
      }));
    }
  }

  const handleNomGerantUpdate = (e) => {
    setNomGerantUpdate(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      nomGerantUpdate: "",
    }));
  }

  const handlePrenomGerantUpdate = (e) => {
    setPrenomGerantUpdate(e.target.value);
    setErrorField((prevErrors) => ({
      ...prevErrors,
      prenomGerantUpdate: "",
    }));
  }

  const handleEmailGerantUpdate = (e) => {
    const isValid = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
    if (!isValid && e.target.value) {
      setErrorField((prevErrors) => ({
        ...prevErrors,
        emailGerantUpdate: "La structure de votre courriel n'est pas correcte.",
      }));
      setEmailGerantUpdate(e.target.value);
    } else {
      setEmailGerantUpdate(e.target.value);
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailGerantUpdate: "",
      }));
    }
  }

  const handleModifierRestaurant = (e) => {
    e.preventDefault();

    if (nomRestaurantUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        nomRestaurantUpdate: "Nom restaurant obligatoire",
      }));
    } else if (nomRestaurantUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        nomRestaurantUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        nomRestaurantUpdate: "",
      }));
    }

    if (adresseUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        adresseUpdate: "Adresse obligatoire",
      }));
    } else if (adresseUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        adresseUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        adresseUpdate: "",
      }));
    }

    if (telephoneUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        telephoneUpdate: "Téléphone obligatoire",
      }));
    } else if (telephoneUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        telephoneUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        telephoneUpdate: "",
      }));
    }


    if (codePostalUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        codePostalUpdate: "Code postal obligatoire",
      }));
    } else if (codePostalUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        codePostalUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        codePostalUpdate: "",
      }));
    }

    if (emailUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailUpdate: "Adresse email obligatoire",
      }));
    } else if (emailUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailUpdate: "",
      }));
    }


    if (nomGerantUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        nomGerantUpdate: "Nom du gérant obligatoire",
      }));
    } else if (nomGerantUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        nomGerantUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        nomGerantUpdate: "",
      }));
    }

    if (prenomGerantUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        prenomGerantUpdate: "Prénom du gérant obligatoire",
      }));
    } else if (prenomGerantUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        prenomGerantUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        prenomGerantUpdate: "",
      }));
    }



    if (emailGerantUpdate === "") {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailGerantUpdate: "Adresse email du gérant obligatoire",
      }));
    } else if (emailGerantUpdate.length < 2) {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailGerantUpdate: "Minimum 2 caractère",
      }));
    } else {
      setErrorFieldUpdate((prevErrors) => ({
        ...prevErrors,
        emailGerantUpdate: "",
      }));
    }

    const isValidEmail = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(emailUpdate);
    const isValidEmailGerant = /^[a-zA-Z0-9\._\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,4}$/.test(emailGerantUpdate);

    if (isValidEmail && isValidEmailGerant && nomRestaurantUpdate !== "" && adresseUpdate !== "" && telephoneUpdate !== "" && codePostalUpdate !== "" && emailUpdate !== "" && nomGerantUpdate !== "" && prenomGerantUpdate !== "" && emailGerantUpdate !== "") {
      setLoadUpdate(true);
      const data = {
        nomRestaurant: nomRestaurantUpdate, adresse: adresseUpdate, telephone: telephoneUpdate,
        codePostal: codePostalUpdate, email: emailUpdate, nomGerant: nomGerantUpdate, prenomGerant: prenomGerantUpdate,
        emailGerant: emailGerantUpdate, telephoneFix: telephoneFixUpdate, telephonePortable: telephonePortableUpdate,
        autreTelephone: autreTelephoneUpdate, nombreSalarier: nombreSalarierUpdate, commentaire: commentaireUpdate,
        equipementAdditionnelle: equipementAdditionnelleUpdate, equipementWifi: equipementWifiUpdate, remarque: remarqueUpdate,
        ville: villeUpdate, nombrePersonne: nombrePersonneUpdate, abonnement: abonnementUpdate
      };
      ModifierRestaurant(updateId, data).then(function (response) {
        if (response.data.title === "success") {
          AfficheRestaurantData();
          toast.success(response.data?.message);
        }
      }).catch(function (error) {
        console.log(error.response);
        toast.warning(error.response.data?.message);
      }).finally(function () {
        setShowModifier(false);
        setLoadUpdate(false);
      });
    }

  }

  const handleSearch = (e) => {
    if (e.target.value !== "") {
      setLoadValue(true);
      let dataFilter = dataResto.filter((resto) => resto.nomRestaurant.toLowerCase().includes(e.target.value.toLowerCase()));
      setDatafilter(dataFilter);
    } else {
      setLoadValue(false);
    }
  }

  const handleAddVisite = (id) => {

    setLoading(true);
    const data = { id: id };
    AuthRestaurantRequest(data).then(function (response) {
      console.log(response);
      localStorage.setItem('tokenRestaurant', response.data.token);
      localStorage.setItem('idResto', JSON.stringify(response.data.donner.id));
      dispatch(AjouteUrlSociete(location.pathname));
      localStorage.setItem('urlSociete', location.pathname);
      dispatch(AjouteRestaurant(response.data.donner));
      if (response.data.title === "success") {
        navigate('/adminRestaurant/presentation');
      }


    }).catch(function (error) {
      console.log(error);
      if (error) {
        toast.error(error.response?.data?.message);
      }

    }).finally(function () {
      setLoading(false);
    });

  }



  return (
    <div>
      <Helmet>
        <title>Gérer restaurants</title>
        <meta name='description' content='Gérer resraurant' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='container'>
        <div className="gererRestaurant">
          <h2 className='text-center'>Total Restaurants {dataRestaurant.length}</h2>
          <div className='header_table'>
            <div className='button_left'>
              {/* <button className='btn'>Trier par :</button> */}
              <input type="text" onChange={handleSearch} placeholder='Nom restaurant ...' className='form-control' />
            </div>
            <div className='button_right'>
              <button className='btn' onClick={() => setShowAjoute(true)}>Créer une fiche</button>
              <button className='btn' onClick={() => setShowEmail(true)}>Envoyer mail à tous les restos</button>
              <button className='btn' onClick={handleExportExel}>Exporter en exel</button>
            </div>
          </div>
          <div className='table-responsive'>
            {loadRestaurant === true || loading === true ?
              <div className="d-flex justify-content-center mt-2">
                <Spinner animation="border" className="load" variant="info" size="md" />
              </div> :
              <table className='table table-bordered'>
                <thead>
                  <tr>
                    <th>Nom Restaurant</th>
                    <th>Email restaurant</th>
                    <th>Ville</th>
                    <th>Gérant</th>
                    {/* <th>Email gérant</th> */}
                    <th>Visite compte</th>
                    <th>Mot de passe</th>
                    <th>Date création</th>
                    <th>Dernière modification</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {restaurantPaginate.length === 0 || dataResto.length === 0 ? <p>Restaurant vide ...</p> :
                    loadValue === true ? dataFilter.length === 0 ? <p>Demande introuvable</p> : dataFilter.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item.nomRestaurant}</td>
                          <td>{item.email}</td>
                          <td>{item.ville}</td>
                          <td>{item.nomGerant} {item.prenomGerant}</td>
                          {/* <td>{item.emailGerant}</td> */}
                          <td><span className='fa fa-address-card' onClick={() => handleAddVisite(item.id)}></span></td>
                          <td>{item.change}</td>
                          <td>{formatDate(new Date(item.dateCreation).getDate()) + "/" + formatDate(parseInt(new Date(item.dateCreation).getMonth() + 1)) + "/" + new Date(item.dateCreation).getFullYear()}</td>
                          <td>{formatDate(new Date(item.dateModification).getDate()) + "/" + formatDate(parseInt(new Date(item.dateModification).getMonth() + 1)) + "/" + new Date(item.dateModification).getFullYear()}</td>
                          <td><span className=' fa fa-edit' onClick={() => handleShowModifier(item)}></span> <span className=' fa fa-trash-o' onClick={() => hendleDeleteRestaurant(item.id)}></span></td>
                        </tr>
                      )
                    }) : restaurantPaginate.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item.nomRestaurant}</td>
                          <td>{item.email}</td>
                          <td>{item.ville}</td>
                          <td>{item.nomGerant} {item.prenomGerant}</td>
                          {/* <td>{item.emailGerant}</td> */}
                          <td><span className='fa fa-address-card' onClick={() => handleAddVisite(item.id)}></span></td>
                          <td>{item.change}</td>
                          <td>{formatDate(new Date(item.dateCreation).getDate()) + "/" + formatDate(parseInt(new Date(item.dateCreation).getMonth() + 1)) + "/" + new Date(item.dateCreation).getFullYear()}</td>
                          <td>{formatDate(new Date(item.dateModification).getDate()) + "/" + formatDate(parseInt(new Date(item.dateModification).getMonth() + 1)) + "/" + new Date(item.dateModification).getFullYear()}</td>
                          <td><span className=' fa fa-edit' onClick={() => handleShowModifier(item)}></span> <span className=' fa fa-trash-o' onClick={() => hendleDeleteRestaurant(item.id)}></span></td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>}

          </div>
          {showPaginate && <div className='d-flex justify-content-center mt-4'>
            <Pagination
              shape="rounded"
              count={Math.ceil(totalPage)}
              onChange={handlePage}
            />
          </div>
          }


          <Modal
            show={showAjoute} onHide={() => setShowAjoute(false)}
            size="xl"

          >
            <Modal.Body>
              <div className='modal_ajouteRestaurant'>
                <div className='ajouteRestaurant_header'>
                  <h3>Créer une fiche Restaurant</h3>
                  <span className='fa fa-close' onClick={() => setShowAjoute(false)}></span>
                </div>
                <div className='ajouteRestaurant_body'>
                  <form onSubmit={handleAddRestaurant}>
                    <div className='d-flex justify-content-center'>
                      <select className="form-select form-select-md" value={abonnement} onChange={handleAbonnement} aria-label="Default select example">

                        {dataAbonnement.map((el, index) => {
                          if (el.id === 0) {
                            return (
                              <option selected key={index} value="">{el.libelle}</option>
                            )
                          } else {
                            return (
                              <option value={el.value} key={index}>{el.libelle}</option>
                            )
                          }

                        })}
                      </select>
                    </div>
                    {errorField.abonnement !== "" ? <span className="text-danger"><small>({errorField.abonnement})</small></span> : ''}
                    <div className='row mt-3'>
                      <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4'>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nom du restaurant <span>*</span></label>
                          <input type="text" className="form-control" value={nomRestaurant} onChange={handleNomRestaurant} id="exampleFormControlInput1" placeholder="Nom restaurant ..." />
                          {errorField.nomRestaurant !== "" ? <span className="text-danger"><small>({errorField.nomRestaurant})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Ville <span>*</span></label>
                          <select className="form-select form-control form-select-md" value={ville} onChange={handleVille} aria-label="Default select example">
                            {villeListe.map((el, index) => {
                              if (el.id === 0) {
                                return (
                                  <option selected key={index} value="">{el.label}</option>
                                )
                              } else {
                                return (
                                  <option value={el.value} key={index}>{el.label}</option>
                                )
                              }

                            })}
                          </select>
                          {errorField.ville !== "" ? <span className="text-danger"><small>({errorField.ville})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Adresse <span>*</span></label>
                          <input type="text" className="form-control" value={adresse} onChange={handleAdresse} id="exampleFormControlInput1" placeholder="Adresse ..." />
                          {errorField.adresse !== "" ? <span className="text-danger"><small>({errorField.adresse})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Code postale<span>*</span></label>
                          <input type="text" className="form-control" value={codePostal} onChange={handleCodePostal} id="exampleFormControlInput1" placeholder="Code postale du resto ..." />
                          {errorField.codePostal !== "" ? <span className="text-danger"><small>({errorField.codePostal})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Adresse mail <span>*</span></label>
                          <input type="email" className="form-control" value={email} onChange={handleEmail} id="exampleFormControlInput1" placeholder="Adresse email du resto ..." />
                          {errorField.email !== "" ? <span className="text-danger"><small>({errorField.email})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nombre de couvert <span>*</span></label>
                          <input type="text" className="form-control" value={nombrePersonne} onChange={handleNombrePersonne} id="exampleFormControlInput1" placeholder="Nombre de personne ..." />
                          {errorField.nombrePersonne !== "" ? <span className="text-danger"><small>({errorField.nombrePersonne})</small></span> : ''}
                        </div>



                      </div>
                      <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4'>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Téléphone du restaurant <span>*</span></label>
                          <input type="text" className="form-control" value={telephone} onChange={handleTelephone} id="exampleFormControlInput1" placeholder="Téléphone du resto ..." />
                          {errorField.telephone !== "" ? <span className="text-danger"><small>({errorField.telephone})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nom du gérant <span>*</span></label>
                          <input type="text" className="form-control" value={nomGerant} onChange={handleNomGerant} id="exampleFormControlInput1" placeholder="Nom du gérant ..." />
                          {errorField.nomGerant !== "" ? <span className="text-danger"><small>({errorField.nomGerant})</small></span> : ''}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Prénom du gérant <span>*</span></label>
                          <input type="text" className="form-control" value={prenomGerant} onChange={handlePrenomGerant} id="exampleFormControlInput1" placeholder="Prénom du gérant ..." />
                          {errorField.prenomGerant !== "" ? <span className="text-danger"><small>({errorField.prenomGerant})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Email du gérant <span>*</span></label>
                          <input type="text" className="form-control" value={emailGerant} onChange={handleEmailGerant} id="exampleFormControlInput1" placeholder="Email gérant ..." />
                          {errorField.emailGerant !== "" ? <span className="text-danger"><small>({errorField.emailGerant})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Téléphone fixe du gérant </label>
                          <input type="text" className="form-control" value={telephoneFix} onChange={handleTelephoneFix} id="exampleFormControlInput1" placeholder="Téléphone fixe ..." />
                          {errorField.telephoneFix !== "" ? <span className="text-danger"><small>({errorField.telephoneFix})</small></span> : ''}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Téléphone portable du gérant</label>
                          <input type="text" className="form-control" value={telephonePortable} onChange={handleTelephonePortable} id="exampleFormControlInput1" placeholder="Téléphone portable ..." />
                          {errorField.telephonePortable !== "" ? <span className="text-danger"><small>({errorField.telephonePortable})</small></span> : ''}
                        </div>



                      </div>
                      <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4'>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Autre numéro de téléphone </label>
                          <input type="text" className="form-control" value={autreTelephone} onChange={handleAutreTelephone} id="exampleFormControlInput1" placeholder="Autre téléphone ..." />
                          {errorField.autreTelephone !== "" ? <span className="text-danger"><small>({errorField.autreTelephone})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nombre de salariés</label>
                          <input type="text" className="form-control" value={nombreSalarier} onChange={handleNombreSalarier} id="exampleFormControlInput1" placeholder="Nombre salarier ..." />
                          {errorField.nombreSalarier !== "" ? <span className="text-danger"><small>({errorField.nombreSalarier})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Commentaire</label>
                          <input type="text" className="form-control" value={commentaire} onChange={handleCommentaire} id="exampleFormControlInput1" placeholder="Commentaire ..." />
                          {errorField.commentaire !== "" ? <span className="text-danger"><small>({errorField.commentaire})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Equipement additionel</label>
                          <input type="text" className="form-control" value={equipementAdditionnelle} onChange={handleEquipementAdditionelle} id="exampleFormControlInput1" placeholder="Equipement additionnelle ..." />
                          {errorField.equipementAdditionnelle !== "" ? <span className="text-danger"><small>({errorField.equipementAdditionnelle})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Equipement wifi</label>
                          <input type="text" className="form-control" value={equipementWifi} onChange={handleEquipementWifi} id="exampleFormControlInput1" placeholder="Equipement wifi ..." />
                          {errorField.equipementWifi !== "" ? <span className="text-danger"><small>({errorField.equipementWifi})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Remarque</label>
                          <input type="text" className="form-control" value={remarque} onChange={handleRemarque} id="exampleFormControlInput1" placeholder="Remarque ..." />
                          {errorField.remarque !== "" ? <span className="text-danger"><small>({errorField.remarque})</small></span> : ''}
                        </div>
                      </div>
                    </div>
                    <span className='required-theme'>(*) Obligatoire</span>
                    <div className='d-flex justify-content-center'>
                      {loadRestaurant === true ? <Button type="button" className='btn btn_ajouteRestaurant' disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          variant="info"
                          className="spiner"
                        />
                        Loading...
                      </Button> : <button type="submit" className='btn'>Valider</button>}

                    </div>
                  </form>
                </div>
              </div>
            </Modal.Body>
          </Modal>



          <Modal
            show={showEmail} onHide={() => setShowEmail(false)}
            size="md"
          >
            <Modal.Body>
              <div className='modal_envoyeEmail'>
                <div className='envoyeEmail_header'>
                  <h3>Partager des messages</h3>
                  <span className='fa fa-close' onClick={() => setShowEmail(false)}></span>
                </div>
                <div className='sendEmai_restaurant'>
                  <form onSubmit={handleEnvoyeEmail}>
                    <div className="mb-3">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Sujet</label>
                      <input type="text" className="form-control" value={sujet} onChange={(e) => setSujet(e.target.value)} required id="exampleFormControlInput1" placeholder="Sujet ..." />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="exampleFormControlTextarea1" className="form-label">Contenu</label>
                      <textarea className="form-control" required value={contenu} onChange={(e) => setContenu(e.target.value)} id="exampleFormControlTextarea1" rows={3} placeholder="contentu ..." />
                    </div>
                    <div className='d-flex justify-content-center'>
                      {loadEmail === true ? <Button type="button" className='btn btn_envoyeEmail' disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          variant="info"
                          className="spiner"
                        />
                        Loading...
                      </Button> :

                        <button type="submit" className='btn'>Partager</button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </Modal.Body>
          </Modal>


          <Modal
            show={showModifier} onHide={() => setShowModifier(false)}
            size="xl"

          >
            <Modal.Body>
              <div className='modal_ajouteRestaurant'>
                <div className='ajouteRestaurant_header'>
                  <h3>Modification du fiche restaurant</h3>
                  <span className='fa fa-close' onClick={() => setShowModifier(false)}></span>
                </div>
                <div className='ajouteRestaurant_body'>
                  <form onSubmit={handleModifierRestaurant}>
                    <div className='d-flex justify-content-center'>
                      <select className="form-select form-select-md" value={abonnementUpdate} onChange={handleUpdateAbonnement} required aria-label="Default select example">
                        {dataAbonnement.map((el, index) => {
                          if (el.id === 0) {
                            return (
                              <option selected key={index} value={el.value}>Selectionner un abonnement</option>
                            )
                          } else {
                            return (
                              <option value={el.value} key={index}>{el.libelle}</option>
                            )
                          }

                        })}
                      </select>
                      {errorFieldUpdate.abonnementUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.abonnementUpdate})</small></span> : ''}
                    </div>
                    <div className='row mt-3'>
                      <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4'>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nom du restaurant <span>*</span></label>
                          <input type="text" className="form-control" value={nomRestaurantUpdate} onChange={handleNomRestaurantUpdate} id="exampleFormControlInput1" placeholder="Nom restaurant ..." />
                          {errorFieldUpdate.nomRestaurantUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.nomRestaurantUpdate})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Ville <span>*</span></label>
                          <select className="form-select form-control form-select-md" value={villeUpdate} onChange={handleVilleUpdate} aria-label="Default select example">
                            {villeListe.map((el, index) => {
                              if (el.id === 0) {
                                return (
                                  <option selected key={index} value={villeUpdate}>{villeUpdate}</option>
                                )
                              } else {
                                return (
                                  <option value={el.value} key={index}>{el.label}</option>
                                )
                              }

                            })}
                          </select>
                          {errorFieldUpdate.villeUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.villeUpdate})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Adresse <span>*</span></label>
                          <input type="text" className="form-control" value={adresseUpdate} onChange={handleAdresseUpdate} id="exampleFormControlInput1" placeholder="Adresse..." />
                          {errorFieldUpdate.adresseUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.adresseUpdate})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Code postale<span>*</span></label>
                          <input type="text" className="form-control" value={codePostalUpdate} onChange={handleCodePostalUpdate} id="exampleFormControlInput1" placeholder="Code postale du resto ..." />
                          {errorFieldUpdate.codePostalUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.codePostalUpdate})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Adresse mail <span>*</span></label>
                          <input type="email" className="form-control" value={emailUpdate} onChange={handleEmailUpdate} id="exampleFormControlInput1" placeholder="Adresse email du resto ..." />
                          {errorFieldUpdate.emailUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.emailUpdate})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nombre de couvert <span>*</span></label>
                          <input type="text" className="form-control" value={nombrePersonneUpdate} onChange={handleNombrePersonneUpdate} id="exampleFormControlInput1" placeholder="Nombre de personne ..." />
                        </div>
                        {errorFieldUpdate.nombrePersonneUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.nombrePersonneUpdate})</small></span> : ''}
                      </div>

                      <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4'>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Téléphone du restaurant <span>*</span></label>
                          <input type="text" className="form-control" value={telephoneUpdate} onChange={handleTelephoneUpdate} id="exampleFormControlInput1" placeholder="Téléphone du resto ..." />
                          {errorFieldUpdate.telephoneUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.telephoneUpdate})</small></span> : ''}
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nom du gérant <span>*</span></label>
                          <input type="text" className="form-control" value={nomGerantUpdate} onChange={handleNomGerantUpdate} id="exampleFormControlInput1" placeholder="Nom du gérant ..." />
                          {errorFieldUpdate.nomGerantUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.nomGerantUpdate})</small></span> : ''}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Prénom du gérant <span>*</span></label>
                          <input type="text" className="form-control" value={prenomGerantUpdate} onChange={handlePrenomGerantUpdate} id="exampleFormControlInput1" placeholder="Prénom du gérant ..." />
                          {errorFieldUpdate.prenomGerantUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.prenomGerantUpdate})</small></span> : ''}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Email du gérant <span>*</span></label>
                          <input type="text" className="form-control" value={emailGerantUpdate} onChange={handleEmailGerantUpdate} id="exampleFormControlInput1" placeholder="Email gérant ..." />
                          {errorFieldUpdate.emailGerantUpdate !== "" ? <span className="text-danger"><small>({errorFieldUpdate.emailGerantUpdate})</small></span> : ''}
                        </div>

                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Téléphone fixe du gérant </label>
                          <input type="text" className="form-control" value={telephoneFixUpdate} onChange={(e) => setTelephoneFixUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Téléphone fixe ..." />
                        </div>

                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Téléphone portable du gérant</label>
                          <input type="text" className="form-control" value={telephonePortableUpdate} onChange={(e) => setTelephonePortableUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Téléphone portable ..." />
                        </div>



                      </div>
                      <div className='col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4'>

                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Autre numéro de téléphone</label>
                          <input type="text" className="form-control" value={autreTelephoneUpdate} onChange={(e) => setAutreTelephoneUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Autre téléphone ..." />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Nombre salariés</label>
                          <input type="text" className="form-control" value={nombreSalarierUpdate} onChange={(e) => setNombreSalarierUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Nombre salarier ..." />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Commentaire</label>
                          <input type="text" className="form-control" value={commentaireUpdate} onChange={(e) => setCommentaireUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Commentaire ..." />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Equipement additionel</label>
                          <input type="text" className="form-control" value={equipementAdditionnelleUpdate} onChange={(e) => setEquipementAdditionnelleUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Equipement additionnelle ..." />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Equipement wifi</label>
                          <input type="text" className="form-control" value={equipementWifiUpdate} onChange={(e) => setEquipementWifiUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Equipement wifi ..." />
                        </div>
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlInput1" className="form-label">Remarque</label>
                          <input type="text" className="form-control" value={remarqueUpdate} onChange={(e) => setRemarqueUpdate(e.target.value)} id="exampleFormControlInput1" placeholder="Remarque ..." />
                        </div>
                      </div>
                    </div>
                    <span className='required-theme'>(*) Obligatoire</span>
                    <div className='d-flex justify-content-center'>
                      {loadUpdate === true ? <Button type="button" className='btn btn_ajouteRestaurant' disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          variant="info"
                          className="spiner"
                        />
                        Loading...
                      </Button> : <button type="submit" className='btn'>Valider</button>}

                    </div>

                  </form>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <p className="version">Version 1</p>
        </div>
      </div>
    </div>
  )
}

export default GererRestaurant


